import React, { useState, useEffect, useRef, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import Header from './components/Header/Header'
import { AllRoutes } from './routes/routes'
import NotFound from './pages/other/NotFound'
import { faSun, faMoon, faCloudMoon } from '@fortawesome/free-solid-svg-icons';

function App() {
    const [store, setStore] = useState({
        browserSettings: {
        },
        themes: [
            {
                name: "light",
                icon: faSun
            },
            {
                name: "dark",
                icon: faMoon
            },
            {
                name: "crescent",
                icon: faCloudMoon
            },
        ],
        notification: null
    });



    const childSetStore = (obj) => {
        if (obj.browserSettings && obj.browserSettings.theme) {
            store.themes.forEach((theme) => {
                if (document.documentElement.classList.contains("theme-" + theme.name) && (obj.browserSettings.theme !== theme.name)) {
                    document.documentElement.classList.remove("theme-" + theme.name);
                }
            })
            if ((obj.browserSettings.theme) && (!document.documentElement.classList.contains("theme-" + obj.browserSettings.theme))) {
                document.documentElement.classList.add("theme-" + obj.browserSettings.theme);
            }
            localStorage.setItem("mainWebBrowserSettings", JSON.stringify(obj.browserSettings))
        }

        setStore({ ...store, ...obj });
    }
    const tempChildSetStore = useRef(childSetStore);

    const oldRedirect = [{
        old: "/itchio",
        new: "/games",
    }, {
        old: "/scratch/:id",
        new: "/games/scratch/:id",
    }]

    useEffect(() => {
        document.getElementById("loading").style.display = "none";
        if (!document.documentElement.classList.contains("theme-light")) {
            document.documentElement.classList.add("theme-light");
        }
        let tempBrowserSettings = {
            theme: "light"
        }
        if (localStorage.getItem("mainWebBrowserSettings")) {
            tempBrowserSettings = { ...tempBrowserSettings, ...JSON.parse(localStorage.getItem("mainWebBrowserSettings")) }
        }
        tempChildSetStore.current({ browserSettings: { ...tempBrowserSettings } })
    }, [])

    return (
        <div style={{width: "100%", height: "100vh"}}>
            <Header provider={{ set: childSetStore, get: store }}/>
            <Switch>
                {AllRoutes.map((route, index) => (
                    <Route key={"route" + index} exact path={route.path}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <route.component provider={{ set: childSetStore, get: store }} />
                        </Suspense>
                    </Route>
                ))}
                {
                    oldRedirect.map((el, index) => (
                        <Redirect key={"redirect"+index} from={el.old} to={el.new} />
                    ))
                }
                <Route path="/">
                    <NotFound/>
                </Route>
            </Switch>
        </div>
    );
}

export default App;
